import { render, staticRenderFns } from "./ContactModalSimple.vue?vue&type=template&id=9b965110&scoped=true&"
import script from "./ContactModalSimple.vue?vue&type=script&lang=js&"
export * from "./ContactModalSimple.vue?vue&type=script&lang=js&"
import style0 from "./ContactModalSimple.vue?vue&type=style&index=0&id=9b965110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b965110",
  null
  
)

export default component.exports